/**
 * Acceso a Direcciones Empleados solo por iderp (no por puesto).
 * 1 Administrador, 568 María Esther Segura, 1312 Paola Zuyin Rodríguez.
 */
export const IDERPS_DIRECCIONES_EMPLEADOS = [1, 568, 1312]

const PATH = 'direccionesempleados'
const PATHS_HERMANOS = [
  'becaempleados',
  'OrganigramaV2',
  'organigramav2',
  'EvaluarEmpleado',
  'ConfiguracionTeachers',
]

export function esAccesoDireccionesEmpleados (iderp) {
  const id = Number(iderp)
  return Number.isFinite(id) && IDERPS_DIRECCIONES_EMPLEADOS.includes(id)
}

function menuTienePath (menu, path) {
  if (!Array.isArray(menu)) return false
  for (const top of menu) {
    for (const cat of top.items || []) {
      if (cat && cat.path === path) return true
      for (const child of cat.items || []) {
        if (child && child.path === path) return true
      }
    }
  }
  return false
}

function quitarPath (menu, path) {
  if (!Array.isArray(menu)) return []
  return menu
    .map((top) => {
      const items = (top.items || [])
        .map((cat) => {
          if (Array.isArray(cat.items) && cat.items.length) {
            return {
              ...cat,
              items: cat.items.filter((child) => child && child.path !== path),
            }
          }
          return cat
        })
        .filter((cat) => {
          if (!cat) return false
          if (cat.path === path) return false
          if (Array.isArray(cat.items) && !cat.items.length && !cat.path) return false
          return true
        })
      return { ...top, items }
    })
    .filter((top) => Array.isArray(top.items) && top.items.length > 0)
}

function itemVista () {
  return {
    title: 'Direcciones Empleados',
    path: PATH,
    icon: 'mdi-map-marker-outline',
    active: 1,
  }
}

function inyectar (menu) {
  const list = Array.isArray(menu) ? menu : []
  const nuevo = itemVista()

  for (const top of list) {
    const items = Array.isArray(top.items) ? top.items : []
    for (let i = 0; i < items.length; i++) {
      const cat = items[i]
      if (cat && PATHS_HERMANOS.includes(cat.path) && !cat.items) {
        items.splice(i + 1, 0, nuevo)
        top.items = items
        return list
      }
      if (cat && Array.isArray(cat.items)) {
        for (let j = 0; j < cat.items.length; j++) {
          if (cat.items[j] && PATHS_HERMANOS.includes(cat.items[j].path)) {
            cat.items.splice(j + 1, 0, nuevo)
            return list
          }
        }
      }
    }
  }

  const norm = (t) => String(t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  let target = list.find((m) => {
    const t = norm(m && m.title)
    return t.includes('recurso') || t.includes('humano') || t === 'rh'
  })
  if (!target) {
    target = {
      title: 'Recursos Humanos',
      idmenu: -99101,
      path: null,
      items: [],
    }
    list.push(target)
  }
  if (!Array.isArray(target.items)) target.items = []
  target.items.push(nuevo)
  return list
}

/**
 * Quita la vista del menú para cualquiera que no esté en la allowlist
 * e inyecta el ítem solo para esos iderp.
 */
export function asegurarMenuDireccionesEmpleados (menu, iderp) {
  const limpio = quitarPath(Array.isArray(menu) ? menu : [], PATH)
  if (!esAccesoDireccionesEmpleados(iderp)) {
    return limpio
  }
  if (menuTienePath(limpio, PATH)) {
    return limpio
  }
  return inyectar(limpio)
}
